// extracted by mini-css-extract-plugin
export default {"CreateServiceAddressForm":"CreateServiceAddressForm_CreateServiceAddressForm__44Y7n","Fields":"CreateServiceAddressForm_Fields__ZTOr9"};